/**
 * Appends the acting-organization cache key to a portal URL.
 *
 * `scope` is a CACHE KEY, not authorization. Without it a signal resource would
 * not re-request when a Davaco Admin switches organization, and the previous
 * customer's rows would stay on screen under the new customer's branding. The
 * actual authorization travels as `X-Acting-Org`, attached by the interceptor
 * and re-checked server-side against the verified token.
 *
 * Encoded even though a slug is a DNS label by construction: the value reaches
 * here from session storage, and one stray `&` would silently rewrite the rest
 * of the query string.
 */
export function scopedUrl(baseUrl: string, path: string, actingSlug: string | null): string {
  const scope: string = actingSlug ?? "self";
  const separator: string = path.includes("?") ? "&" : "?";
  return `${baseUrl}${path}${separator}scope=${encodeURIComponent(scope)}`;
}
